import { useState } from "react";
import { Reveal } from "@/components/Reveal";
import { PageHeader } from "@/pages/Services";
import { useSettings } from "@/context/SettingsContext";
import { api, formatApiError } from "@/lib/api";
import { MapPin, Phone, Mail, Send } from "lucide-react";
import { toast } from "sonner";

export default function Contact() {
  const s = useSettings();
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const { data } = await api.post("/contact", form);
      toast.success(data.message);
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally { setSending(false); }
  };

  return (
    <div>
      <PageHeader eyebrow="Kontak" title="Hubungi Kami" subtitle="Kami siap membantu mewujudkan kebutuhan teknologi Anda. Kunjungi kantor kami di Jakarta." />
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 sm:py-24 grid lg:grid-cols-2 gap-12">
        <Reveal>
          <div className="space-y-6">
            {[
              { icon: MapPin, label: "Alamat Kantor", val: s.address || "Jakarta" },
              { icon: Phone, label: "Telepon", val: s.phone || "+62 21 1234 5678" },
              { icon: Mail, label: "Email", val: s.email || "info@lotuslentera.com" },
            ].map((c) => (
              <div key={c.label} className="flex gap-4 items-start">
                <div className="w-11 h-11 rounded-xl btn-gold flex items-center justify-center shrink-0"><c.icon className="w-5 h-5" /></div>
                <div><div className="text-xs text-white/50 uppercase tracking-widest">{c.label}</div><div className="text-white mt-1">{c.val}</div></div>
              </div>
            ))}
            <div className="rounded-2xl overflow-hidden gold-border mt-4" data-testid="office-map">
              <iframe title="Peta Kantor Jakarta" src={s.map_embed || "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3966.353!2d106.8228!3d-6.2246!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f3e945e34b9d%3A0x5371bf0fdad786a2!2sSudirman!5e0!3m2!1sen!2sid!4v1700000000000"}
                width="100%" height="280" style={{ border: 0, filter: "invert(0.9) hue-rotate(180deg)" }} loading="lazy" />
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <form onSubmit={submit} className="bg-ll-card rounded-2xl p-7 gold-border space-y-4" data-testid="contact-form">
            <h3 className="font-syne font-bold text-xl text-white mb-2">Kirim Pesan</h3>
            <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Nama Lengkap" data-testid="contact-name"
              className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white outline-none focus:border-gold" />
            <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" data-testid="contact-email"
              className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white outline-none focus:border-gold" />
            <input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="No. Telepon / WhatsApp" data-testid="contact-phone"
              className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white outline-none focus:border-gold" />
            <textarea required rows={4} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} placeholder="Pesan Anda" data-testid="contact-message"
              className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-3 text-white outline-none focus:border-gold resize-none" />
            <button disabled={sending} className="btn-gold w-full py-3.5 rounded-xl flex items-center justify-center gap-2 disabled:opacity-60" data-testid="contact-submit">
              <Send className="w-4 h-4" /> {sending ? "Mengirim…" : "Kirim Pesan"}
            </button>
          </form>
        </Reveal>
      </section>
    </div>
  );
}
